const template = `
  <div id="loader">
  	<div class="sa-preloader">
  		<div class="preloader"></div>
  	</div>
  </div>
`

export default template



// WEBPACK FOOTER //
// ./app/utils/loader/template.js